import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'referenceText' })
export class ReferenceTextPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(value: string | null | undefined): SafeHtml {
		if (value == null || typeof value !== 'string') {
			return this.sanitizer.bypassSecurityTrustHtml('');
		}
		const brToNewline = value.replace(/<br\s*\/?>/gi, '\n');
		const escaped = brToNewline
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
		const withBreaks = escaped.replace(/\r\n|\r|\n/g, '<br />');
		return this.sanitizer.bypassSecurityTrustHtml(withBreaks);
	}
}
